import { render } from "./WeeklyForecast.vue?vue&type=template&id=4486db70&scoped=true"
import script from "./WeeklyForecast.vue?vue&type=script&lang=js"
export * from "./WeeklyForecast.vue?vue&type=script&lang=js"

import "./WeeklyForecast.vue?vue&type=style&index=0&id=4486db70&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4486db70"

export default script